module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/approve-login/approve-login.component.css
// module id = ./src/app/components/login/approve-login/approve-login.component.css
// module chunks = main